import { ASYNC_SUCCESS } from '../actions'

const appointments = (state = null, { type, payload }) => {
  switch (type) {
    case ASYNC_SUCCESS:
      switch (payload.actionName) {
        case 'fetchAppointments': {
          if (payload.appointments.length) {
            return [...payload.appointments]
          } else {
            return []
          }
        }
        case 'addContactLog': {
          const { contactLog } = payload
          if (contactLog.data && contactLog.data.reachedType === 'appointment') {
            return state ? [...state, payload.contactLog] : [payload.contactLog]
          } else {
            return state
          }
        }

        default:
          return state
      }

    default:
      return state
  }
}

export default appointments



// WEBPACK FOOTER //
// ./src/reducers/appointments.js